import { Component, input, output } from '@angular/core';
import { TextColor, TextDirective } from '@joii/design-system';
import { LucideInfo, LucideDynamicIcon, LucideX } from '@lucide/angular';
import { JoiiIcon } from '../../icons/lucide/icon';

@Component({
  selector: 'joii-snackbar-toast',
  templateUrl: './snackbar-toast.component.html',
  styleUrl: './snackbar-toast.component.css',
  imports: [LucideDynamicIcon, TextDirective],
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.data-content-color]': 'contentColor()',
    '(click)': 'handleClick($event)',
  },
})
export class SnackbarToastComponent {
  icon = input<JoiiIcon>(LucideInfo);
  closeIcon = input<JoiiIcon>(LucideX);
  message = input<string>('');
  variant = input<SnackbarToastVariant>('info');
  hideClose = input<boolean>(false);
  hideIcon = input<boolean>(false);

  closed = output<Event>();
  clicked = output<Event>();

  protected contentColor(): TextColor {
    return this.variant() === 'highlight' ? 'base' : 'positive';
  }

  handleClose(event: Event): void {
    event.stopPropagation();
    this.closed.emit(event);
  }

  handleClick(event: Event): void {
    this.clicked.emit(event);
  }
}

export type SnackbarToastVariant = 'success' | 'error' | 'warning' | 'info' | 'highlight';
